export const parseBooleanFromString = (str?: string): boolean =>
  str?.toLowerCase() === 'true' || str === '1';
